export const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    
    return date.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    });
};

// Alternative version with custom months if you prefer not to use toLocaleDateString
export const formatDateCustom = (dateString: string): string => {
    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    
    const date = new Date(dateString);
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    
    return `${month} ${day}, ${year}`;
};

// Usage examples:
// formatDate('2024-07-01 14:30:00') => "July 1, 2024"
// formatDateCustom('2024-07-01 14:30:00') => "July 1, 2024" 